/** The template variable a CSAT email must print for the survey to be reachable. */
export const CSAT_SURVEY_LINK_VARIABLE = "survey_link";

/** The 1-5 scale every CSAT surface renders today. */
export const CSAT_RATING_VALUES = [1, 2, 3, 4, 5] as const;

export type CsatRating = (typeof CSAT_RATING_VALUES)[number];

/** Carries the star clicked in the survey email through to the survey page. */
export const CSAT_RATING_QUERY_PARAM = "rating";

export function isCsatRating(value: number): value is CsatRating {
  return (CSAT_RATING_VALUES as readonly number[]).includes(value);
}

/** An unparseable link is returned unchanged, still delivering a working survey. */
export function csatSurveyLinkForRating(
  surveyLink: string,
  rating: CsatRating,
): string {
  try {
    const url = new URL(surveyLink);
    url.searchParams.set(CSAT_RATING_QUERY_PARAM, String(rating));
    return url.toString();
  } catch {
    return surveyLink;
  }
}

/** Reads the prefilled rating back off the survey URL, discarding off-scale values. */
export function parseCsatRatingParam(
  raw: string | null | undefined,
): CsatRating | undefined {
  if (raw == null || raw.trim() === "") {
    return undefined;
  }
  const parsed = Number(raw);
  return isCsatRating(parsed) ? parsed : undefined;
}
